export default __webpack_public_path__ + "static/media/ic_british_indian_ocean_territory.8dad3e4e.svg";